export default __webpack_public_path__ + "static/media/RosaryEvening.b26aee4e.svg";